var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "el-col",
        [
          _c(
            "el-form",
            {
              ref: "tooltipForm",
              attrs: {
                model: _vm.tooltipForm,
                "label-width": "80px",
                size: "mini",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("show"),
                      expression: "showProperty('show')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.show") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeTooltipAttr("show")
                        },
                      },
                      model: {
                        value: _vm.tooltipForm.show,
                        callback: function ($$v) {
                          _vm.$set(_vm.tooltipForm, "show", $$v)
                        },
                        expression: "tooltipForm.show",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.show")))]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tooltipForm.show,
                      expression: "tooltipForm.show",
                    },
                  ],
                },
                [
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("trigger"),
                          expression: "showProperty('trigger')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.trigger_position") },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "mini" },
                          on: {
                            change: function ($event) {
                              return _vm.changeTooltipAttr("trigger")
                            },
                          },
                          model: {
                            value: _vm.tooltipForm.trigger,
                            callback: function ($$v) {
                              _vm.$set(_vm.tooltipForm, "trigger", $$v)
                            },
                            expression: "tooltipForm.trigger",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "item" } }, [
                            _vm._v(_vm._s(_vm.$t("chart.tooltip_item"))),
                          ]),
                          _c("el-radio-button", { attrs: { label: "axis" } }, [
                            _vm._v(_vm._s(_vm.$t("chart.tooltip_axis"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("textStyle"),
                          expression: "showProperty('textStyle')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_fontsize") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("chart.text_fontsize"),
                            size: "mini",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeTooltipAttr("textStyle")
                            },
                          },
                          model: {
                            value: _vm.tooltipForm.textStyle.fontSize,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.tooltipForm.textStyle,
                                "fontSize",
                                $$v
                              )
                            },
                            expression: "tooltipForm.textStyle.fontSize",
                          },
                        },
                        _vm._l(_vm.fontSize, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("textStyle"),
                          expression: "showProperty('textStyle')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_color") },
                    },
                    [
                      _c("el-color-picker", {
                        staticClass: "color-picker-style",
                        attrs: { predefine: _vm.predefineColors },
                        on: {
                          change: function ($event) {
                            return _vm.changeTooltipAttr("textStyle")
                          },
                        },
                        model: {
                          value: _vm.tooltipForm.textStyle.color,
                          callback: function ($$v) {
                            _vm.$set(_vm.tooltipForm.textStyle, "color", $$v)
                          },
                          expression: "tooltipForm.textStyle.color",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("textStyle"),
                          expression: "showProperty('textStyle')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.background") },
                    },
                    [
                      _c("el-color-picker", {
                        staticClass: "color-picker-style",
                        attrs: { predefine: _vm.predefineColors },
                        on: {
                          change: function ($event) {
                            return _vm.changeTooltipAttr("backgroundColor")
                          },
                        },
                        model: {
                          value: _vm.tooltipForm.backgroundColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.tooltipForm, "backgroundColor", $$v)
                          },
                          expression: "tooltipForm.backgroundColor",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("formatter"),
                          expression: "showProperty('formatter')",
                        },
                      ],
                      staticClass: "form-item",
                    },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c(
                          "span",
                          { staticClass: "span-box" },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("chart.content_formatter"))),
                            ]),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: { effect: "dark", placement: "bottom" },
                              },
                              [
                                _c("div", {
                                  attrs: { slot: "content" },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("chart.format_tip")
                                    ),
                                  },
                                  slot: "content",
                                }),
                                _c("i", {
                                  staticClass: "el-icon-info",
                                  staticStyle: { cursor: "pointer" },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 4, maxRows: 4 },
                          placeholder: _vm.$t("chart.formatter_plc"),
                        },
                        on: {
                          blur: function ($event) {
                            return _vm.changeTooltipAttr("formatter")
                          },
                        },
                        model: {
                          value: _vm.tooltipForm.formatter,
                          callback: function ($$v) {
                            _vm.$set(_vm.tooltipForm, "formatter", $$v)
                          },
                          expression: "tooltipForm.formatter",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }